<template>
	<div class="os-container"
		:class="{
			'active' : show
		}">

		<div @click="$emit('close')" class="close-bar"></div>
		<div class="os-content bg-light">
			<h6>Coda chiamate da mandare</h6>
			<div
				@click="resolveQueue"
				v-if="connectionStatus && queue.length > 0"
				class="btn btn-info mb-3 mx-0">
				Esegui chiamate rimaste in background
			</div>
			<div 
				v-for="(req,$index) in queue"
				:key="$index">
					<card class=" mb-3"> 
						<template slot="header">
							<h6 class="mb-0 ">{{modelTitle(req)}}</h6>
							<p class="text-muted">{{req.sendedAt | moment('DD/MM/YYYY hh:mm')}}</p>
						</template>
						<!-- {{req}} -->
					</card>
				</div>
		</div>
	</div>
</template>
<style lang="scss">
	.os-container{
		position: fixed;
		top: 0;
		right: 0;
		left: 100%;
		bottom:0;
		overflow: hidden;
		display: flex;
		transition: all .3s;
		&.active{
			left: 0;
			z-index: 120;
		}
		.close-bar{
			flex:1;
			background:rgba(0,0,0,0.2);
			// @media(min-width: )
		}
		.os-content{
			box-shadow: 0 0 60px -15px rgba(#000,0.4);
			padding: 15px;
			width: 320px;
			overflow-x: hidden;
			overflow-y: auto; 
			.request{
			}
		}
	}

</style>
<script>
	import { mapState, mapActions } from 'vuex'
	export default{
		name: 'offline-queue',
		props: {
			show: Boolean,
		},
		computed: {
			...mapState({
				connectionStatus: state => state.offline.connectionStatus,
				queue: state => state.offline.queue
			}),
		},
		methods: {
			...mapActions('offline', {
				resolveQueue : 'resolveQueue'
			}),
			modelTitle(req) {
				const model = Object.keys(req.data)[0];
				const mappedModel = {
					'revision' : 'una revisione',
					'engine' : 'un motore',
					'site' : 'un cantiere',
					'user' : 'un utente',
				}
				const mappedMethod = {
					'put' : 'Modifica',
					'post' : 'Creazione',
					'delete' : 'Cancellazione',
				}
				return `${mappedMethod[req.method]} di ${mappedModel[model]} `
			}
		}
	}
</script>